export const de = {
	common: {
		continue: "Weiter",
		back: "Zurück",
		cancel: "Abbrechen",
		save: "Speichern",
		delete: "Löschen",
		edit: "Bearbeiten",
		close: "Schließen",
		confirm: "Bestätigen",
		loading: "Laden...",
		error: "Fehler",
		success: "Erfolg",
		warning: "Warnung",
		info: "Info",
		yes: "Ja",
		no: "Nein",
		or: "oder",
		and: "und",
		submit: "Senden",
		apply: "Bewerben",
		withdraw: "Zurückziehen",
		search: "Suchen",
		filter: "Filtern",
		sort: "Sortieren",
		refresh: "Aktualisieren",
		add: "Hinzufügen",
		remove: "Entfernen",
		update: "Aktualisieren",
		view: "Ansehen",
		download: "Herunterladen",
		upload: "Hochladen",
		select: "Auswählen",
		selectAll: "Alle auswählen",
		deselectAll: "Alle abwählen",
		required: "Erforderlich",
		optional: "Optional",
		completed: "Abgeschlossen",
		pending: "Ausstehend",
		inProgress: "In Bearbeitung",
		failed: "Fehlgeschlagen",
		retry: "Erneut versuchen",
		skip: "Überspringen",
		next: "Weiter",
		previous: "Zurück",
		finish: "Fertigstellen",
		start: "Starten",
		stop: "Stoppen",
		pause: "Pausieren",
		resume: "Fortsetzen",
		reset: "Zurücksetzen",
		clear: "Löschen",
		all: "Alle",
		none: "Keine",
		other: "Sonstiges",
		actions: "Aktionen",
		settings: "Einstellungen",
		preferences: "Präferenzen",
		help: "Hilfe",
		about: "Über",
		logout: "Abmelden",
		login: "Anmelden",
		register: "Registrieren",
		profile: "Profil",
		dashboard: "Dashboard",
		home: "Startseite",
		notifications: "Benachrichtigungen",
		messages: "Nachrichten",
		account: "Konto",
		security: "Sicherheit",
		privacy: "Datenschutz",
		language: "Sprache",
		theme: "Design",
		darkMode: "Dunkler Modus",
		lightMode: "Heller Modus",
		systemDefault: "Systemstandard",
		gotIt: "Okay, verstanden",
		tryAgain: "Erneut versuchen",
		clickHere: "Hier klicken",
		confirmDelete: "Löschen bestätigen",
		yesDelete: "Ja, löschen",
		saving: "Speichern...",
		requiredFieldsNote: "Pflichtfelder sind mit einem Sternchen gekennzeichnet",
	},

	// Authentication Flow & Components
	auth: {
		invitations: {
			validating: "Einladung wird validiert...",
			welcome: "Willkommen! Ihre Einladung wurde validiert.",
			invalid:
				"Ungültiger oder abgelaufener Einladungslink. Bitte fordern Sie eine neue Einladung an.",
			expired:
				"Ihre Einladung ist abgelaufen. Bitte fordern Sie eine neue Einladung an.",
		},
		signIn: {
			title: "Anmelden",
			emailLabel: "E-Mail-Adresse",
			emailPlaceholder: "Geben Sie Ihre E-Mail ein",
			passwordLabel: "Passwort",
			passwordPlaceholder: "Geben Sie Ihr Passwort ein",
			noAccount: "Kein Konto mit dieser E-Mail verfügbar",
			checking: "Überprüfung...",
			signingIn: "Anmeldung...",
			welcomeBack: "Willkommen zurück!",
			enterPasswordToContinue: "Geben Sie Ihr Passwort ein, um fortzufahren",
		},
		validation: {
			emailRequired: "E-Mail-Adresse ist erforderlich",
			emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
		},
		errors: {
			unableToCheck:
				"E-Mail kann nicht überprüft werden. Bitte versuchen Sie es erneut.",
			networkError:
				"E-Mail kann nicht überprüft werden. Bitte versuchen Sie es erneut.",
		},
		passwordCreation: {
			title: "Legen Sie Ihr Passwort fest",
			passwordLabel: "Passwort",
			passwordPlaceholder: "Geben Sie Ihr Passwort ein",
			emailVerificationExpired: "E-Mail-Verifizierung ist abgelaufen",
			pleaseVerifyAgain:
				"Bitte verifizieren Sie Ihre E-Mail erneut, um fortzufahren",
			verifyEmail: "E-Mail verifizieren",
			creating: "Passwort wird erstellt...",
			failed: "Passwort konnte nicht erstellt werden",
			requirements: {
				minLength: "Mindestens 8 Zeichen",
				number: "Mindestens eine Zahl",
				uppercase: "Mindestens ein Großbuchstabe",
				special: "Mindestens ein Sonderzeichen",
			},
		},
	},

	authContainer: {
		termsConsent: "Durch das Fortfahren stimmen Sie unseren",
		termsAndConditions: "Allgemeinen Geschäftsbedingungen zu",
	},

	navigation: {
		dashboard: "Dashboard",
		events: "Termine",
		group: "Gruppe",
		chat: "Chat",
		profile: "Profil",
	},

	successScreen: {
		title: "Glückwunsch! Ihr Konto wurde erstellt",
		subtitle:
			"Sie sind startklar! Wählen Sie Ihre nächsten Schritte vom Startbildschirm aus.",
		goToHomeScreen: "Zum Startbildschirm",
	},

	signIn: {
		title: "Anmelden",
		emailLabel: "E-Mail-Adresse",
		emailPlaceholder: "Geben Sie Ihre E-Mail ein",
		passwordLabel: "Passwort",
		passwordPlaceholder: "Geben Sie Ihr Passwort ein",
		forgotPassword: "Passwort vergessen?",
		noAccount: "Kein Konto mit dieser E-Mail verfügbar",
		checking: "Überprüfung...",
		signingIn: "Anmeldung...",
		welcomeBack: "Willkommen zurück!",
		enterPasswordToContinue: "Geben Sie Ihr Passwort ein, um fortzufahren",
	},

	passwordCreation: {
		title: "Legen Sie Ihr Passwort fest",
		passwordLabel: "Passwort",
		passwordPlaceholder: "Geben Sie Ihr Passwort ein",
		requirements: {
			minLength: "Mindestens 8 Zeichen",
			number: "Mindestens 1 Zahl",
			uppercase: "Mindestens 1 Großbuchstabe",
			special: "Mindestens 1 Sonderzeichen",
		},
		creating: "Passwort wird erstellt...",
		failed: "Passwort konnte nicht erstellt werden",
		emailVerificationExpired: "E-Mail-Verifizierung abgelaufen",
		pleaseVerifyAgain:
			"Bitte verifizieren Sie Ihre E-Mail erneut, um fortzufahren.",
		verifyEmail: "E-Mail verifizieren",
	},

	passwordLogin: {
		title: "Anmelden",
		welcomeBack: "Willkommen zurück!",
		enterPassword: "Geben Sie Ihr Passwort ein, um fortzufahren",
		password: "Passwort",
		passwordPlaceholder: "Geben Sie Ihr Passwort ein",
		forgotPassword: "Passwort vergessen?",
		signingIn: "Anmeldung...",
		signIn: "Anmelden",
	},

	emailVerification: {
		title: "E-Mail bestätigen",
		subtitle: "Wir haben einen Bestätigungscode an {{email}} gesendet",
		enterCode: "Bestätigungscode eingeben",
		codePlaceholder: "Geben Sie den 6-stelligen Code ein",
		didntReceive: "Code nicht erhalten?",
		resendCode: "Code erneut senden",
		resendIn: "Code erneut senden in {{seconds}}s",
		verifying: "Verifizierung...",
		verify: "Verifizieren",
		codeSent: "Neuer Code wurde gesendet!",
		invalidCode: "Ungültiger Code. Bitte versuchen Sie es erneut.",
		expired: "Code ist abgelaufen",
		sendingCode: "Code wird gesendet...",
		spamFolderNote:
			"💡 Bitte überprüfen Sie Ihren Spam-/Junk-Ordner, wenn Sie die E-Mail nicht sehen.",
		errors: {
			rateLimitWait:
				"Bitte warten Sie {{seconds}} Sekunden, bevor Sie einen neuen Code anfordern",
			sendFailed: "Bestätigungscode konnte nicht gesendet werden",
			sendFailedTryAgain:
				"Bestätigungscode konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
			invalidCode: "Ungültiger Bestätigungscode",
			verifyFailed:
				"Code konnte nicht verifiziert werden. Bitte versuchen Sie es erneut.",
		},
	},

	phoneNumber: {
		title: "Telefonnummer hinzufügen",
		subtitle: "Wir benötigen Ihre Telefonnummer für wichtige Updates",
		googleSubtitle: "Angemeldet mit",
		label: "Telefonnummer (Handynummer bzw. Mobilnummer)",
		placeholder: "+49XXXXXXXXXX",
		required: "Telefonnummer ist erforderlich",
		invalid: "Bitte geben Sie eine gültige Telefonnummer ein",
		updating: "Aktualisierung...",
		continue: "Weiter",
		errors: {
			general: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
		},
	},

	phoneVerification: {
		title: "Telefonnummer bestätigen",
		subtitle: "Wir haben einen Code an {{phone}} gesendet",
		enterCode: "Bestätigungscode eingeben",
		codePlaceholder: "Geben Sie den 6-stelligen Code ein",
		didntReceive: "Code nicht erhalten?",
		resendCode: "Code erneut senden",
		resendIn: "Code erneut senden in {{seconds}}s",
		verifying: "Verifizierung...",
		verify: "Verifizieren",
		codeSent: "Neuer Code wurde gesendet!",
		invalidCode: "Ungültiger Code. Bitte versuchen Sie es erneut.",
		failedToSend: "SMS-Code konnte nicht gesendet werden",
		failedToVerify:
			"Code konnte nicht verifiziert werden. Bitte versuchen Sie es erneut.",
		emailVerificationExpired: "E-Mail-Verifizierung abgelaufen",
		pleaseVerifyAgain:
			"Bitte verifizieren Sie Ihre E-Mail erneut, um fortzufahren.",
		verifyEmail: "E-Mail verifizieren",
	},

	authFlow: {
		validating: "Ihre Einladung wird überprüft...",
		welcome: "Willkommen! Bitte vervollständigen Sie Ihre Registrierung.",
		invalidLink: "Ungültiger oder abgelaufener Einladungslink",
		linkExpired: "Einladungslink ist abgelaufen",
	},

	// Profile Components
	profile: {
		intro: {
			title: "Profilinformationen",
			description:
				"Wir müssen einige grundlegende Informationen über Sie sammeln, um sicherzustellen, dass Sie alle Anforderungen für den Einsatz als Statist beim Probebetrieb im Terminal 3 erfüllen.",
			usedFor: "Diese Informationen werden verwendet für:",
			personalIdentification: {
				title: "Persönliche Identifikation",
				description:
					"Zur Überprüfung Ihrer Identität für die Sicherheitsfreigabe.",
			},
			communication: {
				title: "Kommunikation",
				description: "Zur Information über Termine und Updates.",
			},
			languageRequirements: {
				title: "Sprache",
				description: "Zur Bestätigung der erforderlichen Sprachkenntnisse.",
			},
			privacyNote:
				"Ihre Daten werden gemäß den deutschen Datenschutzgesetzen behandelt.",
			consentNote:
				"Mit der Fortsetzung stimmen Sie der Erhebung und Verarbeitung Ihrer personenbezogenen Daten zu.",
		},
	},

	profileCompletion: {
		title: "Profil vervollständigen",
		subtitle: "Vervollständigen Sie Ihr Profil, um fortzufahren.",
		personalInfo: "Persönliche Informationen",
		addressInfo: "Adressinformationen",
		saving: "Profil wird gespeichert...",
		saveProfile: "Profil speichern",
		profileSaved: "Profil erfolgreich gespeichert!",
		updateProfile: "Profil aktualisieren",
		fields: {
			firstName: "Vorname",
			firstNamePlaceholder: "Geben Sie Ihren Vornamen ein",
			lastName: "Nachname",
			lastNamePlaceholder: "Geben Sie Ihren Nachnamen ein",
			email: "E-Mail-Adresse",
			phone: "Telefonnummer",
			phoneNumber: "Telefonnummer",
			dateOfBirth: "Geburtsdatum",
			nationality: "Nationalität",
			nationalityPlaceholder: "Nationalität auswählen",
			germanLevel: "Deutschkenntnisse",
			germanLevelPlaceholder: "Deutschniveau auswählen",
			street: "Straße und Hausnummer",
			streetPlaceholder: "Geben Sie Ihre Straßenadresse ein",
			postalCode: "Postleitzahl",
			postalCodePlaceholder: "60549",
			city: "Stadt",
			cityPlaceholder: "Frankfurt am Main",
			cityOfBirth: "Geburtsort",
			cityOfBirthPlaceholder: "Geben Sie Ihren Geburtsort ein",
			occupation: "Hauptbeschäftigung",
			occupationPlaceholder: "Hauptbeschäftigung wählen",
			company: "Firma",
			companyPlaceholder: "Geben Sie Ihren Firmennamen ein",
			department: "Abteilung",
			departmentPlaceholder: "Geben Sie Ihre Abteilung ein",
			flughafenausweisnummer: "Flughafenausweisnummer",
			flughafenausweisnummerPlaceholder:
				"Geben Sie Ihre Flughafenausweisnummer ein",
			ausweisColor: "Ausweisfarbe",
			ausweisColorPlaceholder: "Wählen Sie Ihre Ausweisfarbe",
			occupationProof: "Berufsnachweis hochladen",
		},
		validation: {
			firstNameRequired: "Vorname ist erforderlich",
			lastNameRequired: "Nachname ist erforderlich",
			emailRequired: "E-Mail ist erforderlich",
			mobileRequired: "Handynummer ist erforderlich",
			dateOfBirthRequired: "Geburtsdatum ist erforderlich",
			dateOfBirthFuture: "Geburtsdatum kann nicht in der Zukunft liegen",
			nationalityRequired: "Nationalität ist erforderlich",
			germanLevelRequired: "Deutschniveau ist erforderlich",
			streetRequired: "Straßenadresse ist erforderlich",
			postalCodeRequired: "Postleitzahl ist erforderlich",
			cityRequired: "Stadt ist erforderlich",
			cityOfBirthRequired: "Geburtsort ist erforderlich",
			flughafenausweisnummerRequired: "Flughafenausweisnummer ist erforderlich",
			ausweisfarbeRequired: "Ausweisfarbe ist erforderlich",
			occupationProofRequired: "Bitte laden Sie einen Berufsnachweis hoch",
		},
		recommendedPrerequisites: "Empfohlene Voraussetzungen",
		unableToLoadData:
			"Gespeicherte Profildaten können nicht geladen werden. Sie können das Formular trotzdem manuell ausfüllen.",
		tryAgain: "Erneut versuchen",
		uploadOccupationProof: "Berufsnachweis hochladen",
		occupationProof: "Berufsnachweis",
		germanLevels: {
			A1: "A1 - Anfänger",
			A2: "A2 - Grundlegende Kenntnisse",
			B1: "B1 - Mittelstufe",
			B2: "B2 - Gute Mittelstufe",
			C1: "C1 - Fortgeschrittene Kenntnisse",
			C2: "C2 - Muttersprachler",
			native: "Muttersprachler",
		},
	},

	profileIntro: {
		title: "Profil vervollständigen",
		whyWeNeed: "Warum wir diese Informationen benötigen",
		personalId: "Persönliche Identifikation",
		personalIdDesc:
			"Wir müssen Ihre Identität aus Sicherheits- und rechtlichen Gründen am Frankfurter Flughafen verifizieren.",
		communication: "Kommunikation",
		communicationDesc:
			"Ihre Kontaktdaten helfen uns, wichtige Updates über Probebetriebs- und Zeitpläne zu senden.",
		requirements: "Sprache & Anforderungen",
		requirementsDesc:
			"Das Verständnis Ihres Hintergrunds hilft uns, Sie mit geeigneten Rollen zu verbinden und Unterstützung zu bieten.",
		privacyMatters:
			"Ihre Privatsphäre ist wichtig: Alle Informationen werden verschlüsselt und nur für den Probebetrieb verwendet. Wir befolgen strenge DSGVO-Richtlinien.",
		completeAndContinue: "Vervollständigen & Fortfahren",
		continueToProfile: "Weiter zum Profil",
	},

	profileCompletionOverview: {
		title: "Profilübersicht",
		completionStatus: "Vervollständigungsstatus",
		complete: "Vollständig",
		incomplete: "Unvollständig",
		sections: {
			personal: "Persönliche Daten",
			address: "Adressdaten",
			documents: "Dokumente",
			emergency: "Notfallkontakt",
		},
		profile: "Profil",
		completeYourProfile: "Vervollständigen Sie Ihr Profil",
		airportIdRequired: "Flughafen-ID-Nummer zur Vervollständigung erforderlich",
		yourProfileInformation: "Ihre Profilinformationen",
		fillPersonalInformation: "Geben Sie Ihre persönlichen Informationen ein",
		payrollData: "Steuer- und Bankdaten",
		completePayrollData: "Vervollständigen Sie Ihre Steuer- und Bankdaten",
		payrollDataComplete: "Steuer- und Bankdaten vollständig",
		fillPayrollInformation: "Geben Sie Ihre Steuer- und Bankdaten ein",
		codeOfConduct: "Verhaltenskodex",
		agreeToCodeOfConduct: "Verhaltenskodex zustimmen",
		termsAccepted: "Akzeptiert",
		reviewAndAcceptTerms:
			"Überprüfen und akzeptieren Sie die Geschäftsbedingungen",
		loadingProfileData: "Profildaten werden geladen...",
		sectionsCompleted: "{{completed}} von {{total}} Abschnitten abgeschlossen",
		completeAllSections:
			"Bitte vervollständigen Sie Ihr Profil, um Ihre Bewerbung für den Probebetrieb im Terminal 3 abzuschließen und Ihre Probebetriebstage auszuwählen oder zu bestätigen.",
		next: "Weiter",
		completeAtYourOwnPace: "In Ihrem eigenen Tempo vervollständigen",
		completeTasksInAnyOrder:
			"Sie können diese Aufgaben in beliebiger Reihenfolge erledigen. Jeder Abschnitt speichert Ihren Fortschritt automatisch.",
		nextSuggested: "Nächster Vorschlag:",
		profileCompleted: "Profil vervollständigt!",
		congratulationsMessage:
			"Herzlichen Glückwunsch! Sie haben alle erforderlichen <b>Profilabschnitte</b> ausgefüllt. Bitte gehen Sie zum Bereich <b>Terminvergabe</b>, um Ihre Termine für den Probebetrieb zu wählen oder zu bestätigen.",
	},

	occupationProof: {
		title: "Berufsnachweis hochladen",
		description:
			"Bitte laden Sie ein Dokument hoch, das Ihren Beruf nachweist. Dies kann ein Arbeitsvertrag, eine Arbeitsbescheinigung oder ein ähnliches Dokument sein.",
		acceptedFormats: "Akzeptierte Formate: PDF, JPG, PNG, GIF, DOC, DOCX",
		maxFileSize: "Maximale Dateigröße: 50MB",
		currentDocument: "Aktuelles Dokument",
		download: "Herunterladen",
		delete: "Löschen",
		deleteConfirm:
			"Sind Sie sicher, dass Sie das aktuelle Dokument löschen möchten?",
		uploadNew: "Neues Dokument hochladen",
		uploadDocument: "Dokument hochladen",
		clickToUpload: "Klicken Sie, um eine Datei auszuwählen",
		uploading: "Wird hochgeladen...",
		upload: "Hochladen",
		changeFile: "Ändern",
		fileTooLarge: "Datei ist zu groß. Maximale Größe ist 50MB.",
		preview: "Vorschau",
		previewError: "Vorschau konnte nicht geladen werden",
		previewNotAvailable: "Für diesen Dateityp ist keine Vorschau verfügbar",
	},

	profileData: {
		title: "Profildaten",
		subtitle: "Stellen Sie sicher, dass Ihre Daten korrekt und aktuell sind",
		editProfile: "Profil bearbeiten",
		personalInformation: "Persönliche Informationen",
		contactInformation: "Kontaktinformationen",
		addressInformation: "Adressinformationen",
		additionalInformation: "Zusätzliche Informationen",
		fields: {
			emailAddress: "E-Mail-Adresse",
			firstName: "Vorname",
			lastName: "Nachname",
			phoneNumber: "Telefonnummer",
			dateOfBirth: "Geburtsdatum",
			nationality: "Nationalität",
			germanLevel: "Deutschkenntnisse",
			department: "Abteilung",
			company: "Firma",
			companyPlaceholder: "Firma auswählen",
			departmentPlaceholder: "Geben Sie Ihre Abteilung ein",
			flughafenausweisnummer: "Flughafenausweisnummer",
			flughafenausweisnummerPlaceholder:
				"Geben Sie Ihre Flughafenausweisnummer ein",
			ausweisColor: "Ausweisfarbe",
			ausweisColorPlaceholder: "Wählen Sie Ihre Ausweisfarbe",
			occupation: "Hauptbeschäftigung",
			occupationPlaceholder: "Hauptbeschäftigung wählen",
		},
		selectNationality: "Nationalität auswählen",
		selectGermanLevel: "Deutschkenntnisse auswählen",
		validation: {
			dateOfBirthFuture: "Geburtsdatum kann nicht in der Zukunft liegen",
			allFieldsRequired:
				"Bitte vervollständigen Sie alle erforderlichen Profilinformationen",
		},
		germanLevels: {
			A1: "A1 - Anfänger",
			A2: "A2 - Grundlegende Kenntnisse",
			B1: "B1 - Mittelstufe",
			B2: "B2 - Gute Mittelstufe",
			C1: "C1 - Fortgeschrittene Kenntnisse",
			C2: "C2 - Muttersprachler",
		},
	},

	// Payroll Data Component
	payrollData: {
		title: "Steuer- und Bankdaten",
		subtitle: "Bitte geben Sie Ihre Steuer- und Bankinformationen an",
		bankingInformation: "Bankinformationen",
		taxInformation: "Steuerinformationen",
		save: "Steuer- und Bankdaten speichern",
		fields: {
			iban: "IBAN *",
			ibanPlaceholder: "Bitte geben Sie Ihre IBAN ein",
			bic: "BIC/SWIFT *",
			bicPlaceholder: "Bitte geben Sie Ihre BIC ein",
			differentRecipient: "Abweichender Kontoinhaber",
			differentRecipientPlaceholder: "Kontoinhaber (falls abweichend)",
			differentRecipientInfo:
				"Nur ausfüllen, wenn der Kontoinhaber eine andere Person ist",
			idnr: "Steuer-ID",
			idnrPlaceholder: "Bitte geben Sie Ihre Steuer-ID ein",
			sozialversicherung: "Sozialversicherungsnummer",
			sozialversicherungPlaceholder:
				"Bitte geben Sie Ihre Sozialversicherungsnummer ein",
			noSozialversicherung: "Ich habe keine Sozialversicherungsnummer",
			noSozialversicherungInfo:
				"Bitte geben Sie entweder eine Sozialversicherungsnummer ein oder aktivieren Sie diese Option",
			cityOfBirth: "Geburtsort *",
			cityOfBirthPlaceholder: "Bitte geben Sie Ihren Geburtsort ein",
			countryOfBirth: "Geburtsland *",
			countryOfBirthPlaceholder: "Land auswählen",
			dateOfBirth: "Geburtsdatum *",
			dateOfBirthPlaceholder: "TT.MM.JJJJ",
			geburtsname: "Geburtsname *",
			geburtsnamePlaceholder: "Bitte geben Sie Ihren Geburtsnamen ein",
			geburtsnameInfo:
				"Nur ausfüllen, wenn Ihr Geburtsname von Ihrem aktuellen Namen abweicht",
			gender: "Geschlecht *",
			genderPlaceholder: "Geschlecht auswählen",
			insuranceType: "Versicherungsart *",
			insuranceTypePlaceholder: "Versicherungsart auswählen",
			insuranceCompany: "Krankenkasse *",
			insuranceCompanyPlaceholder: "Bitte geben Sie Ihre Krankenkasse ein",
			hauptAg: "ucm ist mein Hauptarbeitgeber",
		},
		genderOptions: {
			male: "Männlich",
			female: "Weiblich",
			divers: "Divers",
			noSpecified: "Keine Angabe",
		},
		insuranceTypes: {
			gesetzlich: "Gesetzlich versichert",
			privat: "Privat versichert",
		},
		validation: {
			ibanRequired: "IBAN ist erforderlich",
			ibanInvalid: "Bitte geben Sie eine gültige IBAN ein",
			bicRequired: "BIC ist erforderlich",
			bicInvalid: "Bitte geben Sie einen gültigen BIC/SWIFT-Code ein",
			idnrRequired: "Steuer-ID ist erforderlich",
			idnrInvalid: "Bitte geben Sie eine gültige Steuer-ID ein",
			sozialversicherungOrCheckbox:
				"Bitte geben Sie eine Sozialversicherungsnummer ein oder aktivieren Sie die Option 'Ich habe keine Sozialversicherungsnummer'",
			sozialversicherungLength:
				"Die Sozialversicherungsnummer muss genau 12 Zeichen lang sein",
			sozialversicherung9thChar:
				"Das 9. Zeichen der Sozialversicherungsnummer muss ein Großbuchstabe sein",
			cityOfBirthRequired:
				"Geburtsort ist erforderlich (wenn keine Sozialversicherungsnummer vorhanden)",
			countryOfBirthRequired:
				"Geburtsland ist erforderlich (wenn keine Sozialversicherungsnummer vorhanden)",
			dateOfBirthRequired:
				"Geburtsdatum ist erforderlich (wenn keine Sozialversicherungsnummer vorhanden)",
			geburtsnameRequired:
				"Geburtsname ist erforderlich (wenn keine Sozialversicherungsnummer vorhanden)",
			genderRequired: "Geschlecht ist erforderlich",
			insuranceTypeRequired: "Versicherungsart ist erforderlich",
			insuranceCompanyRequired: "Krankenkasse ist erforderlich",
			allFieldsRequired: "Bitte füllen Sie alle erforderlichen Felder aus",
		},
		tooltips: {
			idnr: "Über die Vergabe Ihrer Identifikationsnummer werden Sie vom Bundeszentralamt für Steuern (BZSt) durch ein Mitteilungsschreiben informiert. In der Regel finden Sie Ihre Identifikationsnummer auch auf Ihrem letzten Einkommensteuerbescheid oder auf Ihrer Lohnsteuerbescheinigung.",
			hauptAg:
				"Bitte geben Sie an, ob es sich bei dieser Beschäftigung bei ucm um Ihre Haupt- oder Nebenbeschäftigung handelt. Nur eine Hauptbeschäftigung kann mit StKl I bis V abgerechnet werden.",
		},
	},

	// Contract & Financial Components
	contractData: {
		title: "Vertragsdaten",
		subtitle:
			"Bitte geben Sie Ihre Beschäftigungsinformationen für die Vertragsverarbeitung an.",
		currentEmploymentStatus: "Aktueller Beschäftigungsstatus *",
		selectEmploymentType: "Beschäftigungsart auswählen",
		employmentTypes: {
			fullTime: "Vollzeitbeschäftigt",
			partTime: "Teilzeitbeschäftigt",
			freelancer: "Freiberufler",
			student: "Student",
			unemployed: "Arbeitslos",
			retired: "Im Ruhestand",
		},
		employmentPermissionDocument: "Arbeitsgenehmigungsdokument",
		documentRequired:
			"Erforderlich, wenn Sie oben 'Vollzeitbeschäftigt' ausgewählt haben",
		uploadDocument: "Dokument hochladen (PDF, DOC, DOCX)",
		needTemplate: "Benötigen Sie die Arbeitsgenehmigungsvorlage?",
		downloadTemplate: "Vorlagendokument herunterladen",
		save: "Vertragsdaten speichern",
		validation: {
			employmentTypeRequired: "Beschäftigungsart ist erforderlich",
			documentRequired:
				"Arbeitsgenehmigungsdokument ist für Vollzeitbeschäftigte erforderlich",
		},
	},

	payrollInfo: {
		title: "Gehaltsinformationen",
		subtitle: "Ihre Bank- und Steuerdaten für die Gehaltsabrechnung",
		bankingInformation: "Bankinformationen",
		iban: "IBAN",
		ibanPlaceholder: "DE89 3704 0044 0532 0130 00",
		bic: "BIC/SWIFT",
		bicPlaceholder: "COBADEFFXXX",
		bankName: "Bankname",
		bankNamePlaceholder: "Commerzbank AG",
		accountHolder: "Kontoinhaber",
		accountHolderPlaceholder: "Name des Kontoinhabers eingeben",
		taxInformation: "Steuerinformationen",
		taxId: "Steuer-ID",
		taxIdPlaceholder: "12345678901",
		socialSecurityNumber: "Sozialversicherungsnummer",
		socialSecurityNumberPlaceholder:
			"Geben Sie Ihre Sozialversicherungsnummer ein",
		taxClass: "Steuerklasse",
		selectTaxClass: "Steuerklasse auswählen",
		taxClasses: {
			class1: "Klasse 1 (Ledig, keine Kinder)",
			class2: "Klasse 2 (Alleinerziehend)",
			class3: "Klasse 3 (Verheiratet, Hauptverdiener)",
			class4: "Klasse 4 (Verheiratet, ähnliches Einkommen)",
			class5: "Klasse 5 (Verheiratet, Geringverdiener)",
			class6: "Klasse 6 (Zweitbeschäftigung)",
		},
		churchTax: "Kirchensteuerpflichtig",
		healthInsuranceProvider: "Krankenversicherung",
		healthInsuranceProviderPlaceholder: "z.B. AOK, TK, Barmer",
		save: "Gehaltsinformationen speichern",
		validation: {
			ibanRequired: "IBAN ist erforderlich",
			bicRequired: "BIC ist erforderlich",
			bankNameRequired: "Bankname ist erforderlich",
			accountHolderRequired: "Kontoinhaber ist erforderlich",
			taxIdRequired: "Steuer-ID ist erforderlich",
			socialSecurityNumberRequired:
				"Sozialversicherungsnummer ist erforderlich",
			taxClassRequired: "Steuerklasse ist erforderlich",
			healthInsuranceProviderRequired: "Krankenversicherung ist erforderlich",
		},
	},

	financialData: {
		title: "Finanzdaten",
		subtitle: "Geben Sie Ihre Bankdaten für die Gehaltsabrechnung ein",
		iban: "IBAN",
		ibanPlaceholder: "DE89 3704 0044 0532 0130 00",
		bic: "BIC/SWIFT",
		bicPlaceholder: "COBADEFFXXX",
		accountHolder: "Kontoinhaber",
		accountHolderPlaceholder: "Kontoinhabername eingeben",
		taxClass: "Steuerklasse",
		taxId: "Steuer-ID",
		taxIdPlaceholder: "Ihre Steuer-ID eingeben",
		socialSecurity: "Sozialversicherungsnummer",
		socialSecurityPlaceholder: "Ihre Sozialversicherungsnummer eingeben",
		employmentType: "Beschäftigungsart",
		religion: "Religion (für Kirchensteuer)",
		saving: "Finanzdaten werden gespeichert...",
		save: "Finanzdaten speichern",
		validation: {
			ibanRequired: "IBAN ist erforderlich",
			ibanInvalid: "Ungültige IBAN",
			bicRequired: "BIC ist erforderlich",
			accountHolderRequired: "Kontoinhaber ist erforderlich",
			taxClassRequired: "Steuerklasse ist erforderlich",
			socialSecurityRequired: "Sozialversicherungsnummer ist erforderlich",
		},
	},

	billingData: {
		title: "Rechnungsdaten",
		subtitle: "Geben Sie Ihre Rechnungsinformationen ein",
		companyName: "Firmenname",
		vatId: "USt-IdNr.",
		billingAddress: "Rechnungsadresse",
		save: "Rechnungsdaten speichern",
	},

	payrollInfoIntro: {
		title: "Gehaltsabrechnung einrichten",
		subtitle: "Lassen Sie uns Ihre Zahlungsinformationen konfigurieren",
		why: "Warum wir diese Informationen benötigen",
		reason1: "Pünktliche Zahlung",
		reason1Desc: "Sicherstellung, dass Sie rechtzeitig bezahlt werden",
		reason2: "Steuer-Compliance",
		reason2Desc: "Korrekte Berechnung und Abführung von Steuern",
		reason3: "Sozialversicherung",
		reason3Desc: "Verwaltung Ihrer Sozialversicherungsbeiträge",
		continue: "Weiter zur Gehaltsabrechnung",
	},

	// Event Components

	eventApplicationIntro: {
		title: "Terminvergabe für den Probebetrieb",
		subtitle: "Nehmen Sie am Probebetrieb des Frankfurter Flughafens teil",
		why: "Was Sie erwartet",
		benefit1: "Praktische Erfahrung",
		benefit1Desc: "Sammeln Sie wertvolle Erfahrungen im Flughafenbetrieb",
		benefit2: "Faire Vergütung",
		benefit2Desc:
			"Erhalten Sie eine wettbewerbsfähige Vergütung für Ihre Teilnahme",
		benefit3: "Flexible Zeitplanung",
		benefit3Desc: "Wählen Sie Schichten, die zu Ihrem Zeitplan passen",
		continue: "Verfügbare Termine anzeigen",
	},

	eventDetails: {
		title: "Probebetriebsdetails",
		date: "Datum",
		time: "Zeit",
		location: "Ort",
		duration: "Dauer",
		participants: "Teilnehmer",
		description: "Beschreibung",
		requirements: "Anforderungen",
		status: "Status",
		apply: "Bewerben",
		withdraw: "Zurückziehen",
		viewDetails: "Details anzeigen",
		contractMissing: "Vertrag fehlt",
		preWorkCheckin: "Bereit für Vorab-Check-in",
		readyForWork: "Arbeitsbereit",
		approved: "Genehmigt",
		payrolled: "Abgerechnet",
		statusDescriptions: {
			contractMissing:
				"Vervollständigen Sie die Vertragsdaten, um fortzufahren",
			preWorkCheckin: "Bereit für Vorab-Check-in",
			readyForWork: "Alle Anforderungen erfüllt, arbeitsbereit",
			approved: "Teilnahme am Termin genehmigt",
			payrolled: "Zahlung erfolgreich verarbeitet",
		},
	},

	onboardingWelcome: {
		welcome: "Willkommen bei ucm!",
		setupInMinutes:
			"Lassen Sie uns in nur wenigen Minuten ihr Profil einrichten.",
		loadingProfile: "Lade Ihr Profil...",
		getStarted: "Loslegen",
		skipSetup: "Einrichtung überspringen",
		completed: "Abgeschlossen",
		// Step titles
		steps: {
			profile: "Profil vervollständigen",
			eventApplication: "Terminvergabe für den Probebetrieb",
			codeOfConduct: "Verhaltenskodex zustimmen",
		},
	},

	onboardingStep: {
		stepIndicator: "Schritt {{current}} von {{total}}",
		completeSetup:
			"Vervollständigen Sie diesen Schritt, um mit der Einrichtung fortzufahren",
		whatHappensNext: "Was passiert als Nächstes?",
		whatHappensNextDescription:
			'Klicken Sie auf "Profil vervollständigen", um diesen Schritt abzuschließen, oder auf "Vorerst überspringen", um ihn später über Ihr Dashboard zu erledigen.',
		skipForNow: "Vorerst überspringen",
		invalidStep: "Ungültiger Schritt",
		unknownStep: "Unbekannter Schritt",
		continue: "Weiter",
		loadingProgress: "Fortschritt wird geladen...",
		// Step specific content
		profile: {
			title: "Profil vervollständigen",
			description:
				"Geben Sie Ihre persönlichen und Kontaktdaten für die Sicherheits- und Rechtskonformität am Frankfurter Flughafen ein.",
			action: "Profil vervollständigen",
		},
		eventApp: {
			title: "Terminvergabe für den Probebetrieb",
			description:
				"Wählen Sie Ihre verfügbaren Termine für den Probebetrieb aus, damit wir Sie für passende Schichten buchen können.",
			action: "Verfügbare Termine wählen",
		},
		codeOfConduct: {
			title: "Verhaltenskodex zustimmen",
			description:
				"Prüfen und akzeptieren Sie die Geschäftsbedingungen für die Teilnahme als Statist beim Probebetrieb im Terminal 3 am Frankfurter Flughafen.",
			action: "Prüfen und Akzeptieren",
		},
	},

	eventApplication: {
		title: "Für Probebetrieb bewerben",
		subtitle:
			"Wählen Sie die Zeitfenster aus, in denen Sie für die Teilnahme am Probebetrieb des Frankfurter Flughafens Terminal 2 verfügbar sind.",
		confirmApplication: "Bewerbung bestätigen",
		applyToEvents: "Für {{count}} neue Termine bewerben",
		applyToEventsPlural: "Für {{count}} neue Termine bewerben:",
		confirmWithdrawal: "Rückzug bestätigen",
		withdrawFromEvent: "Von diesem Termin zurückziehen:",
		canReapplyLater:
			"Sie können sich später bei Bedarf erneut für diesen Termin bewerben.",
		cancel: "Abbrechen",
		confirm: "Bestätigen",
		applying: "Wird beworben...",
		withdraw: "Zurückziehen",
		withdrawing: "Wird zurückgezogen...",
		dateTBD: "Datum noch offen",
		available: "Verfügbar:",
		applied: "Beworben",
		booked: "Gebucht",
		cancelled: "Abgesagt",
		withdrawn: "Zurückgezogen",
		fullyBooked: "Ausgebucht",
		required: "Benötigt",
		noEventsAvailable: "Derzeit sind keine Termine verfügbar.",
		checkBackLater: "Bitte schauen Sie später noch einmal vorbei.",
		submitApplication: "Bewerbung einreichen",
		alreadyApplied: "Bereits für ausgewählte Termine beworben",
		profileIncompleteTitle: "Vervollständigen Sie zuerst Ihr Profil",
		profileIncompleteMessage:
			"Sie müssen Ihr Profil vervollständigen, bevor Sie Termine für den Probebetrieb auswählen können. Dazu gehören alle persönlichen Informationen, Vertragsdaten und Gehaltsabrechnungsdetails.",
		completeProfile: "Profil vervollständigen",
		note: "Hinweis:",
		saveChanges: "Änderungen speichern",
		noChangesToSave: "Keine Änderungen zu speichern",
		// New translations
		jobTitle: "Frankfurt Airport Inspector",
		jobLocation: "Flughafen Frankfurt, Terminal 3",
		terminalLocation: "Terminal 3",
		shortDescription:
			"Wir starten in ein neues Jahr am BER mit dir am Flughafen! Mit dem neuen Jahr begrüßt dich unser neuer Shopleiter, Sebastian, mit...",
		fullDescription:
			"Wir starten in ein neues Jahr am BER mit dir am Flughafen! Mit dem neuen Jahr begrüßt dich unser neuer Shopleiter, Sebastian, mit einem neuen Team und neuen Möglichkeiten. Als Airport Inspector wirst du Teil eines dynamischen Teams, das für die Sicherheit und den reibungslosen Ablauf am Flughafen sorgt. Deine Aufgaben umfassen die Überprüfung von Sicherheitsprotokollen, die Unterstützung bei Passagierkontrollen und die Zusammenarbeit mit verschiedenen Abteilungen.",
		seeMore: "Mehr anzeigen",
		seeLess: "Weniger anzeigen",
		availableDates: "Verfügbare Termine",
		noEvents: "Keine Termine",
		retry: "Erneut versuchen",
		confirmChanges: "Änderungen bestätigen",
		changesDescription: "Sie sind dabei, folgende Änderungen vorzunehmen:",
		applyTo: "Bewerben auf",
		withdrawFrom: "Zurückziehen von",
		marketingDatesTitle: "Vorab ausgewählte Termine verfügbar",
		marketingDatesDescription:
			"Sie haben vorab in Ihrer Bewerbung Termine ausgewählt, die jetzt zur Buchung verfügbar sind.",
		marketingDatesPreselected:
			"Dies sind die Termine, die Sie beim Ausfüllen des Formulars ursprünglich ausgewählt haben:",
		applyToSelected: "Anwenden",
		event: "Termin für den Probebetrieb",
		events: "Termine für den Probebetrieb",
		updating: "Wird aktualisiert...",
		cannotWithdrawTitle: "Abmeldung nicht möglich - Gruppenanmeldungen",
		cannotWithdrawDescription:
			"Die folgenden Termine wurden von Ihrem Gruppenleiter ausgewählt und können nicht abgemeldet werden. Bitte kontaktieren Sie Ihren Gruppenleiter, wenn Sie sich von diesen Terminen abmelden möchten.",
		groupApplied: "Gruppenanmeldung",
		ordinalSuffixes: {
			th: ".",
			st: ".",
			nd: ".",
			rd: ".",
		},
		noteMessage:
			"Sie können mehrere Termine auswählen. Änderungen werden gespeichert, wenn Sie Ihre Bewerbung einreichen.",
		requirements: "Anforderungen",
		completedProfileAndContract: "Vollständige Profil- und Vertragsdaten",
		signedCodeOfConduct: "Unterschriebene Verhaltenskodex-Vereinbarung",
		loadingEvents: "Termine werden geladen...",
		selectedEvents: "Ausgewählt: {{count}} Termine",
		submitNewEvents: "Bewerbung einreichen ({{count}} neue Termine)",
		submitNewEventsPlural: "Bewerbung einreichen ({{count}} neue Termine)",
		applicant: "Bewerber",
		applicants: "Bewerber",
	},

	combinedEventDashboard: {
		title: "Probebetriebsdetails",
		eventDetailScreen: "Probebetriebsdetails",
		loadingEvents: "Ihre Termine werden geladen...",
		myEvents: "Meine Termine",
		upcomingEvents: "Bevorstehende Termine des Probebetriebs",
		pastEvents: "Vergangene Termine des Probebetriebs",
		availableEvents: "Verfügbare Termine",
		noJobSelected: "Kein Job ausgewählt",
		loading: "Wird geladen...",
		cancelled: "Abgesagt",
		addToGoogleCalendar: "Zu Google Kalender hinzufügen",
		addEventToGoogleCalendar: "Termin zu Google Kalender hinzufügen",
		airportEvent: "Flughafen-Termin",
		internal: "Intern",
		external: "Extern",
		frankfurtAirportTerminal: "Frankfurter Flughafen Terminal 3",
		status: "Status",
		booked: "Gebucht",
		eventCancelledSuccessfully: "Termin erfolgreich abgesagt",
		failedToCancelEvent:
			"Termin konnte nicht abgesagt werden. Bitte versuchen Sie es erneut.",
		jobTitle: "Frankfurter Flughafen-Inspektor",
		company: "Flughafensicherheit",
		location: "Terminal 3 - Sicherheitskontrolle",
		duties: "Ihre Aufgaben umfassen gründliche Inspektionen von",
		securityCheckpoints: "Sicherheitskontrollpunkte",
		monitoringPassengerFlow: "Überwachung des Passagierflusses",
		safetyRegulationsManual: "Sicherheitsvorschriften-Handbuch",
		safetyRegulationsDesc: "Dieses Dokument beschreibt alle",
		inspectionChecklist: "Inspektions-Checkliste",
		inspectionChecklistDesc: "Eine umfassende Checkliste zur Sicherstellung",
		emergencyProceduresGuide: "Notfallverfahren-Leitfaden",
		emergencyProceduresDesc: "Machen Sie sich vertraut mit den",
		trainingMaterials: "Schulungsmaterialien",
		trainingMaterialsDesc:
			"Überprüfen Sie diese Materialien, um auf dem neuesten Stand zu bleiben",
		loadingYourEvents: "Ihre Termine werden geladen...",
		cancelThisEvent: "Diesen Termin absagen",
		filters: {
			all: "Alle",
			upcoming: "Bevorstehend",
			past: "Vergangen",
			applied: "Beworben",
			booked: "Gebucht",
			cancelled: "Abgesagt",
		},
		cancellation: {
			title: "Termin absagen?",
			question: "Warum möchten Sie absagen?",
			reason: "Grund für Absage",
			reasons: {
				personalEmergency: "Persönlicher Notfall",
				scheduleConflict: "Terminkonflikt",
				healthIssues: "Gesundheitliche Probleme",
				transportationProblems: "Transportprobleme",
				familyObligations: "Familiäre Verpflichtungen",
				workConflict: "Arbeitskonflikt",
				other: "Sonstiges",
			},
			specifyReason: "Bitte geben Sie Ihren Grund an...",
			enterReason: "Bitte geben Sie Ihren Grund ein",
			confirm: "Absage bestätigen",
			selectReason: "Wählen Sie einen Grund, um fortzufahren",
			cancel: "Abbrechen",
			cancelling: "Wird abgesagt...",
			cancellationFailed: "Absage fehlgeschlagen",
			cancelEventQuestion: "Termin absagen?",
			whyCancelQuestion: "Warum möchten Sie absagen?",
			characters: "Zeichen",
			pleaseSpecifyReason: "Bitte geben Sie Ihren Grund an...",
			charactersRemaining: "Zeichen",
		},
		cannotCancelGroupEvent:
			"Dieser Termin wurde von Ihrem Gruppenleiter gebucht und kann nicht einzeln storniert werden. Bitte kontaktieren Sie Ihren Gruppenleiter zur Stornierung.",
		groupBookingTitle: "Gruppenbuchung",
		groupBookingMessage:
			"Dieser Termin wurde von Ihrem Gruppenleiter gebucht. Nur der Gruppenleiter kann Gruppenbuchungen stornieren.",
		noEventsTitle: "Noch keine gebuchten Termine für den Probebetrieb",
		noEventsMessage:
			"Sie wurden noch zu keinen Terminen des Probebetriebs gebucht. Bitte wählen Sie Termine aus, falls Sie dies noch nicht getan haben. Wir informieren Sie, sobald Sie fest zugewiesen wurden.",
		noEventsSubMessage:
			"Bitte schauen Sie später noch einmal vorbei oder warten Sie auf eine Benachrichtigung von uns.",
	},

	jobDetail: {
		noJobSelected: "Kein Job ausgewählt",
		id: "ID",
		taskList: "Aufgabenliste",
		taskListAvailable:
			"Die Aufgabenliste wird verfügbar sein, sobald Sie den Job annehmen",
		jobDetail: "Job-Details",
		jobDescription:
			"Als Flughafensicherheitsinspektor sind Sie verantwortlich für die Einhaltung von Sicherheitsvorschriften und -protokollen am Flughafen.",
		duties: "Ihre Aufgaben umfassen gründliche Inspektionen von",
		securityCheckpoints: "Sicherheitskontrollpunkte",
		monitoringPassengerFlow: "Überwachung des Passagierflusses",
		collaborating:
			"Zusammenarbeit mit Sicherheitspersonal zur Bewältigung potenzieller Gefahren.",
		reportPreparation:
			"Sie erstellen auch detaillierte Berichte über Inspektionsergebnisse und empfehlen Verbesserungen zur Erhöhung der Sicherheitsmaßnahmen.",
		roleRequirements:
			"Diese Rolle erfordert ausgeprägte Aufmerksamkeit für Details, ausgezeichnete Kommunikationsfähigkeiten und die Fähigkeit, in einer schnelllebigen Umgebung zu arbeiten.",
		user: "Benutzer",
		needHelp: "Brauchen Sie Hilfe?",
		howToGetAssistance: "Wie möchten Sie Unterstützung erhalten?",
		readFAQs: "FAQs lesen",
		title: "Auftragsdetails",
		providedDocument: "Bereitgestelltes Dokument",
		inspectionDocumentsDesc:
			"Um eine gründliche Flughafeninspektion durchzuführen, beziehen Sie sich bitte auf die folgenden von dem Flughafenteam bereitgestellten Dokumente:",
		safetyRegulationsManual: "Sicherheitsvorschriften-Handbuch",
		safetyRegulationsManualDesc:
			"Dieses Dokument beschreibt alle Sicherheitsprotokolle, die bei Inspektionen eingehalten werden müssen.",
		inspectionChecklist: "Inspektions-Checkliste",
		inspectionChecklistDesc:
			"Eine umfassende Checkliste, um sicherzustellen, dass alle Bereiche bei Ihrer Inspektion abgedeckt werden.",
		incidentReportForms: "Vorfallsberichtsformulare",
		incidentReportFormsDesc:
			"Verwenden Sie diese Formulare, um Sicherheitsvorfälle oder Gefahren zu dokumentieren.",
		emergencyProceduresGuide: "Notfallverfahren-Leitfaden",
		emergencyProceduresGuideDesc:
			"Machen Sie sich mit den Verfahren vertraut, die im Notfall zu befolgen sind.",
		trainingMaterials: "Schulungsmaterialien",
		trainingMaterialsDesc:
			"Überprüfen Sie diese Materialien, um über bewährte Praktiken und Sicherheitsmaßnahmen auf dem Laufenden zu bleiben.",
		documentReminder:
			"Stellen Sie sicher, dass Sie diese Dokumente während Ihrer Inspektion griffbereit haben, um Compliance und Sicherheit zu gewährleisten.",
		cancel: "Abbrechen",
	},

	taskList: {
		title: "Aufgabendetails",
		availableInFuture: "Aufgaben werden in Zukunft verfügbar sein",
		taskDetail: "Aufgabendetails",
	},

	dashboard: {
		title: "Dashboard",
		myEvents: "Meine Termine",
		upcomingEvents: "Bevorstehende Termine",
		jobTitle: "Frankfurter Flughafen-Inspektor",
		company: "Flughafensicherheit",
		location: "Terminal 3 - Sicherheitskontrolle",
		addToCalendar: "Zu Google Kalender hinzufügen",
		callContact: "Kontakt anrufen",
		taskList: "Aufgabenliste",
		downloadContract: "Vertrag herunterladen",
		sendSignedContract: "Unterschriebenen Vertrag senden",
		processingContract: "Vertrag wird bearbeitet",
		downloadUCMContract: "UCM-Vertrag herunterladen",
		completeIDCheck: "ID-Prüfung abschließen",
		readyForWork: "Arbeitsbereit",
		awaitingSupervisor: "Warten auf Supervisor-Check-in",
		inDays: "In {{days}} Tagen",
	},

	// Task & Dashboard Components
	taskDashboard: {
		title: "Aufgaben-Dashboard",
		welcome: "Willkommen",
		welcomeWithName: "Willkommen, {{name}}",
		viewNotifications: "Benachrichtigungen und Updates anzeigen",
		tasksToComplete: "Zu erledigende Aufgaben",
		completedTasks: "Erledigte Aufgaben",
		tasks: {
			completeProfile: "Profil vervollständigen",
			profileCompletion: "Profilvervollständigung",
			applyForEvent: "Terminvergabe für den Probebetrieb",
			seeEventDetails: "Probebetriebsdetails anzeigen",
			adjustYourGroup: "Gruppe anpassen",
			contract: "Vertrag",
			payroll: "Lohnabrechnung",
			readCodeOfConduct: "Verhaltenskodex lesen",
			uploadDocuments: "Dokumente hochladen",
			completeTraining: "Schulung abschließen",
			applyForEvents: "Terminvergabe für den Probebetrieb",
		},
		viewAll: "Alle anzeigen",
		markComplete: "Als erledigt markieren",
		inProgress: "In Bearbeitung",
		notStarted: "Nicht begonnen",
		completed: "Abgeschlossen",
	},

	mainApp: {
		title: "UCM Airport Inspector",
		navigation: {
			dashboard: "Dashboard",
			profile: "Profil",
			events: "Termine",
			documents: "Dokumente",
			training: "Schulung",
			settings: "Einstellungen",
			help: "Hilfe",
			logout: "Abmelden",
		},
		welcomeMessage: "Willkommen bei UCM Airport Inspector",
		loadingUser: "Benutzerdaten werden geladen...",
		errorLoadingUser: "Fehler beim Laden der Benutzerdaten",
		sessionExpired:
			"Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
	},

	// Code of Conduct
	codeOfConduct: {
		title: "Verhaltenskodex",
		accepted: "Sie haben den Verhaltenskodex akzeptiert.",
		pleaseRead:
			"Bitte lesen und akzeptieren Sie unseren Verhaltenskodex, um am Probebetrieb teilzunehmen.",
		status: "Status: Akzeptiert",
		scrollToBottom: "Bitte scrollen Sie nach unten",
		scrollToContinue: "Bitte scrollen Sie nach unten, um fortzufahren",
		accept: "Verhaltenskodex akzeptieren",
		decline: "Ablehnen",
		alreadyAccepted: "Bereits akzeptiert",
		processing: "Verarbeitung...",
		agreements: {
			conduct:
				"Ich halte professionelles Verhalten ein und behandle alle Personen respektvoll.",
			safety:
				"Ich befolge alle Sicherheitsvorschriften (inkl. Rauch-/Feuer-/Alkoholverbot) und melde Vorfälle sofort.",
			confidentiality:
				"Ich wahre Vertraulichkeit und beachte die Regeln zu Foto/Film, Daten- und Zutrittsrechten.",
			uniform:
				"Ich halte die vorgeschriebenen Uniform-/Ausrüstungs- und Erscheinungsstandards ein und nutze Infrastruktur nur bestimmungsgemäß.",
			workingHours:
				"Teilnahme während der Arbeitszeit wurde mit dem Vorgesetzten abgestimmt.",
		},
		sections: {
			validity: {
				title: "Geltung & Weisungen",
				content:
					"Den Anweisungen des Personals vor Ort ist stets Folge zu leisten.",
			},
			professional: {
				title: "Professionelles Verhalten",
				content:
					"Respektvoller Umgang mit allen Personen; keine diskriminierende Sprache oder Handlungen.",
			},
			access: {
				title: "Zutritt & Ausweise",
				content:
					"Zutritt nur über freigegebene Eingänge und nur in berechtigte Bereiche. Sie müssen sich bei der Bundespolizei ausweisen können; interne Verkehrsregeln gelten.",
			},
			safetyFirst: {
				title: "Sicherheit zuerst",
				content:
					"Alle Sicherheitsprotokolle befolgen, Vorfälle/Gefahren sofort melden. Rauchen, offenes Feuer und eigenmächtige Arbeiten mit Brandgefahr sind verboten.",
			},
			alcoholDrugs: {
				title: "Alkohol/Drogen",
				content:
					"Das Erscheinen im alkoholisierten oder berauschten Zustand führt automatisch zu einem Ausschluss vom Probebetrieb.",
			},
			vehicles: {
				title: "Fahrzeuge & Geräte",
				content:
					"Nur zugelassene/versicherte Fahrzeuge auf Betriebsflächen; Parken nur gekennzeichnet. Bodenabfertigungs-/Terminal-Infrastruktur nur bestimmungsgemäß nutzen.",
			},
			dangerousGoods: {
				title: "Gefahrgut & verbotene Gegenstände",
				content:
					"Vorschriften strikt einhalten; unzulässige Gegenstände werden entnommen/entsorgt.",
			},
			photoVideo: {
				title: "Werbung",
				content:
					"Nur mit vorheriger Genehmigung; Versammlungen/Promotionen sind anmelde- und genehmigungspflichtig.",
			},
			animalsDrones: {
				title: "Tiere & Drohnen",
				content:
					"Keine Tiere auf Betriebsflächen; Füttern von Wildtieren verboten. Drohnen/UAVs grundsätzlich untersagt.",
			},
			cleanlinessEnvironment: {
				title: "Sauberkeit & Umwelt",
				content:
					"Abfälle beseitigen; Leckagen/Verunreinigungen sofort melden und aufnehmen; nur normales Abwasser einleiten.",
			},
			dataPrivacy: {
				title: "Datenschutz/Video",
				content:
					"Videoüberwachung vorhanden; Daten können bei schwerwiegendem Verstoß gegen den Verhaltenskodex zur Strafverfolgung genutzt werden.",
			},
			consequences: {
				title: "Folgen bei Verstößen",
				content:
					"Verweis vom Gelände, Ausweissperre, Vertragskündigung und ggf. rechtliche Schritte.",
			},
		},
	},

	// Settings
	appSettings: {
		title: "Einstellungen",
		subtitle: "Verwalten Sie Ihre App-Einstellungen",
		menuItems: {
			fontSize: "Schriftgröße",
			setting1: "Einstellung 1",
			setting2: "Einstellung 2",
			setting3: "Einstellung 3",
		},
		sections: {
			account: "Kontoeinstellungen",
			notifications: "Benachrichtigungen",
			privacy: "Datenschutz & Sicherheit",
			appearance: "Erscheinungsbild",
			language: "Sprache",
			help: "Hilfe & Support",
		},
		account: {
			changePassword: "Passwort ändern",
			twoFactor: "Zwei-Faktor-Authentifizierung",
			deleteAccount: "Konto löschen",
			exportData: "Daten exportieren",
		},
		notifications: {
			emailNotifications: "E-Mail-Benachrichtigungen",
			pushNotifications: "Push-Benachrichtigungen",
			smsNotifications: "SMS-Benachrichtigungen",
			eventReminders: "Terminerinnerungen",
			applicationUpdates: "Bewerbungsupdates",
			systemAnnouncements: "Systemankündigungen",
		},
		privacy: {
			dataSharing: "Datenfreigabe",
			activityTracking: "Aktivitätsverfolgung",
			cookieSettings: "Cookie-Einstellungen",
			privacyPolicy: "Datenschutzrichtlinie",
			termsOfService: "Nutzungsbedingungen",
		},
		appearance: {
			theme: "Design",
			fontSize: "Schriftgröße",
			colorScheme: "Farbschema",
			compactMode: "Kompaktmodus",
		},
		language: {
			interfaceLanguage: "Oberflächensprache",
			selectLanguage: "Sprache auswählen",
			dateFormat: "Datumsformat",
			timeFormat: "Zeitformat",
			timezone: "Zeitzone",
			currency: "Währung",
		},
		help: {
			userGuide: "Benutzerhandbuch",
			faq: "Häufig gestellte Fragen",
			contactSupport: "Support kontaktieren",
			reportBug: "Fehler melden",
			feedback: "Feedback geben",
		},
	},

	// Notifications
	notifications: {
		title: "Benachrichtigungen",
		markAllRead: "Alle als gelesen markieren",
		clearAll: "Alle löschen",
		noNotifications: "Keine neuen Benachrichtigungen",
		types: {
			info: "Information",
			success: "Erfolg",
			warning: "Warnung",
			error: "Fehler",
			system: "System",
		},
		messages: {
			payrollDataMissing: "Lohn- und Steuerdaten unvollständig",
			payrollDataMissingDesc:
				"Vervollständigen Sie Ihre Lohn- und Steuerdaten für Bewerbungen.",
			contractRequired: "Vertragsdaten erforderlich",
			contractRequiredDesc:
				"Bitte vervollständigen Sie Ihre Vertragsdaten, um mit der Terminauswahl für den Probebetrieb fortzufahren.",
			eventUpdate: "Termin-Update",
			eventApproved: "Ihre Bewerbung für {{date}} wurde genehmigt!",
			paymentInfo: "Zahlungsinformationen benötigt",
			paymentInfoDesc:
				"Um Ihre Vergütung zu erhalten, vervollständigen Sie bitte Ihre Zahlungsinformationen.",
			profileIncomplete: "Profil unvollständig",
			profileIncompleteDesc:
				"Bitte vervollständigen Sie Ihr Profil, um alle Funktionen nutzen zu können.",
			documentExpiring: "Dokument läuft ab",
			documentExpiringDesc: "Ihr {{document}} läuft in {{days}} Tagen ab.",
			trainingAvailable: "Neue Schulung verfügbar",
			trainingAvailableDesc:
				"Eine neue Schulung '{{training}}' ist jetzt verfügbar.",
		},
		actions: {
			view: "Ansehen",
			complete: "Vervollständigen",
			dismiss: "Verwerfen",
			remindLater: "Später erinnern",
		},
	},

	// Groups

	// Training & Webinars
	trainingBooking: {
		title: "Schulungsbuchung",
		availableTrainings: "Verfügbare Schulungen",
		myTrainings: "Meine Schulungen",
		upcomingTrainings: "Bevorstehende Schulungen",
		completedTrainings: "Abgeschlossene Schulungen",
		bookTraining: "Schulung buchen",
		cancelBooking: "Buchung stornieren",
		viewDetails: "Details anzeigen",
		certificate: "Zertifikat",
		downloadCertificate: "Zertifikat herunterladen",
		duration: "Dauer",
		instructor: "Ausbilder",
		capacity: "Kapazität",
		enrolled: "Angemeldet",
		status: {
			notStarted: "Nicht begonnen",
			inProgress: "In Bearbeitung",
			completed: "Abgeschlossen",
			cancelled: "Abgesagt",
		},
	},

	webinarBooking: {
		title: "Webinar-Buchung",
		availableWebinars: "Verfügbare Webinare",
		myWebinars: "Meine Webinare",
		upcomingWebinars: "Bevorstehende Webinare",
		pastWebinars: "Vergangene Webinare",
		registerWebinar: "Für Webinar registrieren",
		cancelRegistration: "Registrierung stornieren",
		joinWebinar: "Webinar beitreten",
		watchRecording: "Aufzeichnung ansehen",
		presenter: "Moderator",
		duration: "Dauer",
		registeredCount: "{{count}} registriert",
		maxParticipants: "Max. {{count}} Teilnehmer",
	},

	// Appointments
	appointments: {
		title: "Termine",
		myAppointments: "Meine Termine",
		scheduleAppointment: "Termin vereinbaren",
		cancelAppointment: "Termin absagen",
		rescheduleAppointment: "Termin verschieben",
		appointmentDetails: "Termindetails",
		purpose: "Zweck",
		withWhom: "Mit",
		location: "Ort",
		date: "Datum",
		time: "Zeit",
		duration: "Dauer",
		notes: "Notizen",
		reminder: "Erinnerung",
		status: {
			scheduled: "Geplant",
			confirmed: "Bestätigt",
			cancelled: "Abgesagt",
			completed: "Abgeschlossen",
			noShow: "Nicht erschienen",
		},
		types: {
			interview: "Vorstellungsgespräch",
			training: "Schulung",
			medical: "Medizinisch",
			documentation: "Dokumentation",
			orientation: "Einführung",
			other: "Sonstiges",
		},
	},

	// Contracts
	contracts: {
		title: "Verträge",
		myContracts: "Meine Verträge",
		currentContract: "Aktueller Vertrag",
		previousContracts: "Frühere Verträge",
		contractDetails: "Vertragsdetails",
		viewContract: "Vertrag ansehen",
		downloadContract: "Vertrag herunterladen",
		signContract: "Vertrag unterzeichnen",
		contractNumber: "Vertragsnummer",
		type: "Vertragsart",
		startDate: "Startdatum",
		endDate: "Enddatum",
		status: {
			draft: "Entwurf",
			pending: "Ausstehend",
			active: "Aktiv",
			expired: "Abgelaufen",
			terminated: "Beendet",
		},
		types: {
			permanent: "Unbefristet",
			temporary: "Befristet",
			partTime: "Teilzeit",
			fullTime: "Vollzeit",
			freelance: "Freiberuflich",
			internship: "Praktikum",
		},
	},

	// ID Verification
	idCapture: {
		title: "Ausweiserfassung",
		subtitle: "Bitte fotografieren Sie Ihren Ausweis",
		frontSide: "Vorderseite",
		backSide: "Rückseite",
		takePicture: "Foto aufnehmen",
		retake: "Erneut aufnehmen",
		upload: "Hochladen",
		continue: "Weiter",
		instructions: {
			title: "Anweisungen",
			goodLighting: "Sorgen Sie für gute Beleuchtung",
			noGlare: "Vermeiden Sie Blendung",
			inFocus: "Stellen Sie sicher, dass das Dokument scharf ist",
			fullDocument: "Erfassen Sie das gesamte Dokument",
		},
		errors: {
			uploadFailed: "Hochladen fehlgeschlagen. Bitte versuchen Sie es erneut.",
			invalidFormat:
				"Ungültiges Dateiformat. Bitte verwenden Sie JPG oder PNG.",
			fileTooLarge: "Datei zu groß. Maximale Größe ist 10MB.",
		},
		placeIdInFrame: "Platzieren Sie die Vorderseite Ihres Ausweises im Rahmen",
		placeNewIdInFrame: "Platzieren Sie Ihren neuen Ausweis im Rahmen",
		replacingIdPhoto: "Ersetze vorhandenes Ausweis-Foto",
		captureTips: "Aufnahme-Tipps",
	},

	idResult: {
		title: "Verifizierungsergebnis",
		verified: "Verifiziert",
		notVerified: "Nicht verifiziert",
		pending: "Ausstehend",
		documentType: "Dokumenttyp",
		documentNumber: "Dokumentnummer",
		expiryDate: "Ablaufdatum",
		issuingCountry: "Ausstellungsland",
		retry: "Foto ersetzen",
		continue: "Weiter",
		newDocumentVerified:
			"Ihr neues Ausweisdokument wurde erfolgreich verifiziert und aktualisiert.",
		documentVerified:
			"Ihr Ausweisdokument wurde erfolgreich verifiziert und ist einsatzbereit.",
		documentTypeLabel: "Dokumenttyp: Personalausweis",
		uploadDate: "Upload-Datum: {{date}}",
		uploadDateUnknown: "Upload-Datum: Unbekannt",
		status: "Status:",
		verifiedStatus: "✅ Verifiziert",
		replacementInfo:
			"Sie können Ihr Ausweis-Foto bei Bedarf bis zu 2 Mal ersetzen.",
		replacementsRemaining: "Verbleibende Ersetzungen: {{count}}/2",
		noReplacementsLeft: "Keine weiteren Ersetzungen verfügbar",
		deleteDialog: {
			title: "Ausweis-Dokument löschen",
			message:
				"Sind Sie sicher, dass Sie Ihr Ausweis-Dokument löschen möchten? Dies setzt Ihren Verifizierungsstatus zurück und Sie müssen ein neues Dokument hochladen.",
			cancel: "Abbrechen",
			confirm: "Dokument löschen",
		},
	},

	idTerms: {
		agreement: "Einverständniserklärung",
		iAgree: "Ich stimme zu",
		terms: {
			dataUsage: "Ihre ID-Daten werden nur zur Verifizierung verwendet",
			dataStorage: "Daten werden sicher gespeichert und verschlüsselt",
			dataRetention: "Daten werden gemäß DSGVO-Richtlinien aufbewahrt",
			dataAccess: "Nur autorisiertes Personal hat Zugriff auf Ihre Daten",
		},
		title: "ID-Daten eingeben",
		personalIdData: "Personalausweis Daten",
		idNumber: "Personalausweisnummer",
		idNumberPlaceholder: "Geben Sie Ihre Personalausweisnummer ein",
		firstName: "Vorname (wie auf dem Personalausweis)",
		firstNamePlaceholder: "Vorname",
		lastName: "Nachname",
		lastNamePlaceholder: "Nachname",
		dateOfBirth: "Geburtsdatum",
		placeOfBirth: "Geburtsort",
		placeOfBirthPlaceholder: "Stadt/Ort der Geburt",
		validateData: "Daten validieren",
		validated: "Validiert",
		validationSuccessful: "Validierung erfolgreich",
		validationSuccessMessage: "Ihre ID-Daten wurden erfolgreich validiert.",
		cancel: "Cancel",
		validation: {
			idNumberRequired: "Personalausweisnummer ist erforderlich",
			firstNameRequired: "Vorname ist erforderlich",
			lastNameRequired: "Nachname ist erforderlich",
			dateOfBirthRequired: "Geburtsdatum ist erforderlich",
			placeOfBirthRequired: "Geburtsort ist erforderlich",
		},
	},

	// Check-in/Check-out
	checkInList: {
		title: "Check-in Liste",
		searchPlaceholder: "Nach Name oder ID suchen...",
		checkIn: "Einchecken",
		checkInAll: "Alle einchecken",
		checkedIn: "Eingecheckt",
		notCheckedIn: "Nicht eingecheckt",
		checkInTime: "Check-in Zeit",
		expectedArrival: "Erwartete Ankunft",
		lateArrival: "Verspätete Ankunft",
		noShow: "Nicht erschienen",
		total: "Gesamt",
		present: "Anwesend",
		absent: "Abwesend",
	},

	checkOutList: {
		title: "Check-out Liste",
		searchPlaceholder: "Nach Name oder ID suchen...",
		checkOut: "Auschecken",
		checkOutAll: "Alle auschecken",
		checkedOut: "Ausgecheckt",
		notCheckedOut: "Nicht ausgecheckt",
		checkOutTime: "Check-out Zeit",
		expectedDeparture: "Erwartete Abreise",
		overtime: "Überstunden",
		earlyDeparture: "Frühe Abreise",
		hoursWorked: "Gearbeitete Stunden",
	},

	// Validation Messages
	validation: {
		required: "{{field}} ist erforderlich",
		invalid: "{{field}} ist ungültig",
		tooShort: "{{field}} ist zu kurz",
		tooLong: "{{field}} ist zu lang",
		mustMatch: "{{field}} muss übereinstimmen",
		mustBeDifferent: "{{field}} muss unterschiedlich sein",
		mustBeUnique: "{{field}} muss eindeutig sein",
		invalidFormat: "Ungültiges Format für {{field}}",
		outOfRange: "{{field}} liegt außerhalb des gültigen Bereichs",
		fileTooBig: "Datei ist zu groß (max. {{size}})",
		unsupportedFileType: "Nicht unterstützter Dateityp",
		networkError: "Netzwerkfehler. Bitte versuchen Sie es erneut.",
		serverError: "Serverfehler. Bitte versuchen Sie es später erneut.",
		unauthorized: "Nicht autorisiert. Bitte melden Sie sich an.",
		forbidden: "Zugriff verweigert.",
		notFound: "Nicht gefunden.",
		conflict: "Konflikt. Ressource existiert bereits.",
		tooManyRequests: "Zu viele Anfragen. Bitte versuchen Sie es später erneut.",
	},

	// Events Section
	events: {
		event: "Termin",
		noEvent: "Kein Termin",
		noEvents: "Kein Termin gefunden",
		tryAgain: "Erneut versuchen",
	},

	// Documents Section
	documents: {
		providedDocument: "Bereitgestellte Dokumente",
		inspectionDocuments:
			"Für eine gründliche Flughafeninspektion beachten Sie bitte die folgenden vom Flughafenteam bereitgestellten Dokumente:",
		safetyRegulationsManual: "Sicherheitsvorschriften-Handbuch",
		safetyRegulationsDesc:
			"Dieses Dokument beschreibt alle Sicherheitsprotokolle, die während der Inspektionen eingehalten werden müssen.",
		inspectionChecklist: "Inspektions-Checkliste",
		inspectionChecklistDesc:
			"Eine umfassende Checkliste, um sicherzustellen, dass alle Bereiche während Ihrer Inspektion abgedeckt werden.",
		incidentReportForms: "Vorfallberichtsformulare",
		incidentReportFormsDesc:
			"Verwenden Sie diese Formulare zur Dokumentation von Sicherheitsvorfällen oder erkannten Gefahren.",
		emergencyProceduresGuide: "Notfallverfahren-Leitfaden",
		emergencyProceduresDesc:
			"Machen Sie sich mit den Verfahren vertraut, die im Notfall zu befolgen sind.",
		trainingMaterials: "Schulungsmaterialien",
		trainingMaterialsDesc:
			"Überprüfen Sie diese Materialien, um über bewährte Verfahren und Sicherheitsmaßnahmen auf dem Laufenden zu bleiben.",
		documentReminder:
			"Stellen Sie sicher, dass Sie diese Dokumente während Ihrer Inspektion zur Hand haben, um Compliance und Sicherheit zu gewährleisten.",
	},

	// Error Messages
	errors: {
		general: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
		network: "Netzwerkfehler. Bitte überprüfen Sie Ihre Internetverbindung.",
		unauthorized: "Sie sind nicht berechtigt, diese Aktion durchzuführen.",
		notFound: "Die angeforderte Ressource wurde nicht gefunden.",
		validation:
			"Bitte überprüfen Sie Ihre Eingaben und versuchen Sie es erneut.",
		serverError: "Serverfehler. Bitte versuchen Sie es später erneut.",
		timeout: "Anfrage-Timeout. Bitte versuchen Sie es erneut.",
		offline: "Sie sind offline. Bitte überprüfen Sie Ihre Internetverbindung.",
		updateRequired:
			"App-Update erforderlich. Bitte aktualisieren Sie auf die neueste Version.",
		maintenanceMode:
			"System befindet sich im Wartungsmodus. Bitte versuchen Sie es später erneut.",
		errorLoading: "Fehler beim Laden der Daten",
	},

	// Success Messages
	success: {
		saved: "Erfolgreich gespeichert!",
		updated: "Erfolgreich aktualisiert!",
		deleted: "Erfolgreich gelöscht!",
		created: "Erfolgreich erstellt!",
		sent: "Erfolgreich gesendet!",
		uploaded: "Erfolgreich hochgeladen!",
		downloaded: "Erfolgreich heruntergeladen!",
		copied: "In Zwischenablage kopiert!",
		applied: "Erfolgreich beworben!",
		withdrawn: "Erfolgreich zurückgezogen!",
		cancelled: "Erfolgreich abgesagt!",
		completed: "Erfolgreich abgeschlossen!",
		verified: "Erfolgreich verifiziert!",
		approved: "Erfolgreich genehmigt!",
		rejected: "Erfolgreich abgelehnt!",
		loggedIn: "Erfolgreich angemeldet!",
		loggedOut: "Erfolgreich abgemeldet!",
		registered: "Erfolgreich registriert!",
		subscribed: "Erfolgreich abonniert!",
		unsubscribed: "Erfolgreich abgemeldet!",
	},

	// Info Messages
	info: {
		loading: "Laden...",
		processing: "Verarbeitung...",
		saving: "Speichern...",
		sending: "Senden...",
		uploading: "Hochladen...",
		downloading: "Herunterladen...",
		pleaseWait: "Bitte warten...",
		noData: "Keine Daten verfügbar",
		noResults: "Keine Ergebnisse gefunden",
		endOfResults: "Ende der Ergebnisse",
		pullToRefresh: "Zum Aktualisieren ziehen",
		releaseToRefresh: "Zum Aktualisieren loslassen",
		lastUpdated: "Zuletzt aktualisiert: {{time}}",
		version: "Version {{version}}",
		poweredBy: "Powered by {{name}}",
	},

	// Warning Messages
	warnings: {
		unsavedChanges:
			"Sie haben ungespeicherte Änderungen. Möchten Sie wirklich fortfahren?",
		deleteConfirmation:
			"Sind Sie sicher, dass Sie dies löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
		logoutConfirmation: "Sind Sie sicher, dass Sie sich abmelden möchten?",
		cancelConfirmation:
			"Sind Sie sicher, dass Sie abbrechen möchten? Alle ungespeicherten Änderungen gehen verloren.",
		dataLoss:
			"Diese Aktion kann zu Datenverlust führen. Möchten Sie fortfahren?",
		irreversibleAction:
			"Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher?",
		maintenanceScheduled: "Geplante Wartung am {{date}} um {{time}}",
		sessionExpiring: "Ihre Sitzung läuft in {{minutes}} Minuten ab",
		weakPassword:
			"Ihr Passwort ist schwach. Bitte wählen Sie ein stärkeres Passwort.",
		outdatedBrowser:
			"Ihr Browser ist veraltet. Bitte aktualisieren Sie für die beste Erfahrung.",
	},

	// Date & Time
	dateTime: {
		today: "Heute",
		yesterday: "Gestern",
		tomorrow: "Morgen",
		now: "Jetzt",
		ago: "vor",
		in: "in",
		seconds: "Sekunden",
		minute: "Minute",
		minutes: "Minuten",
		hour: "Stunde",
		hours: "Stunden",
		day: "Tag",
		days: "Tage",
		week: "Woche",
		weeks: "Wochen",
		month: "Monat",
		months: "Monate",
		year: "Jahr",
		years: "Jahre",
		monday: "Montag",
		tuesday: "Dienstag",
		wednesday: "Mittwoch",
		thursday: "Donnerstag",
		friday: "Freitag",
		saturday: "Samstag",
		sunday: "Sonntag",
		january: "Januar",
		february: "Februar",
		march: "März",
		april: "April",
		may: "Mai",
		june: "Juni",
		july: "Juli",
		august: "August",
		september: "September",
		october: "Oktober",
		november: "November",
		december: "Dezember",
		am: "AM",
		pm: "PM",
		dateFormat: "DD.MM.YYYY",
		timeFormat: "HH:mm",
		dateTimeFormat: "DD.MM.YYYY HH:mm",
	},

	// Numbers & Currency
	numbers: {
		thousand: "Tausend",
		million: "Million",
		billion: "Milliarde",
		decimal: ",",
		thousands: ".",
		currency: "€",
		currencyName: "Euro",
		percentage: "%",
	},

	// File Types
	fileTypes: {
		pdf: "PDF-Dokument",
		doc: "Word-Dokument",
		xls: "Excel-Tabelle",
		ppt: "PowerPoint-Präsentation",
		txt: "Textdatei",
		img: "Bild",
		video: "Video",
		audio: "Audio",
		zip: "Archiv",
		unknown: "Unbekannter Dateityp",
	},

	profileInformation: {
		title: "Ihr Profil",
		loadingTitle: "Profil wird geladen...",
		savingProfile: "Profil wird gespeichert...",
		fields: {
			firstName: "Vorname",
			lastName: "Nachname",
			email: "E-Mail",
			phoneNumber: "Telefonnummer",
			dateOfBirth: "Geburtsdatum",
			cityOfBirth: "Geburtsort",
			street: "Straße",
			postcode: "Postleitzahl",
			city: "Stadt",
			nationality: "Nationalität",
			germanLevel: "Deutschkenntnisse",
			occupation: "Hauptbeschäftigung",
		},
		placeholders: {
			firstName: "Vorname eingeben",
			lastName: "Nachname eingeben",
			email: "E-Mail",
			phoneNumber: "Telefonnummer",
			cityOfBirth: "Geburtsort eingeben",
			street: "Straße eingeben",
			postcode: "Postleitzahl eingeben",
			city: "Stadt eingeben",
			selectNationality: "Nationalität wählen",
			selectGermanLevel: "Deutschkenntnisse wählen",
			selectOccupation: "Hauptbeschäftigung wählen",
		},
		errors: {
			firstNameRequired: "Vorname ist erforderlich",
			lastNameRequired: "Nachname ist erforderlich",
			dateOfBirthRequired: "Geburtsdatum ist erforderlich",
			dateOfBirthFuture: "Geburtsdatum kann nicht in der Zukunft liegen",
			cityOfBirthRequired: "Geburtsort ist erforderlich",
			nationalityRequired: "Nationalität ist erforderlich",
			germanLevelRequired: "Deutschkenntnisse sind erforderlich",
			streetRequired: "Straße ist erforderlich",
			postcodeRequired: "Postleitzahl ist erforderlich",
			cityRequired: "Stadt ist erforderlich",
			flughafenausweisnummerRequired: "Flughafenausweisnummer ist erforderlich",
			ausweisfarbeRequired: "Ausweisfarbe ist erforderlich",
		},
	},

	forgotPassword: {
		title: "Passwort vergessen",
		subtitle:
			"Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.",
		emailLabel: "E-Mail-Adresse",
		emailPlaceholder: "name@beispiel.de",
		emailRequired: "Bitte geben Sie Ihre E-Mail-Adresse ein",
		sendResetLink: "Link zum Zurücksetzen senden",
		sending: "Wird gesendet...",
		rememberPassword: "Passwort wieder eingefallen?",
		backToSignIn: "Zurück zur Anmeldung",
		successTitle: "E-Mail überprüfen",
		successSubtitle:
			"Wir haben einen Link zum Zurücksetzen des Passworts gesendet an",
		successMessage:
			"Bitte überprüfen Sie Ihre E-Mail und folgen Sie den Anweisungen, um Ihr Passwort zurückzusetzen. Der Link läuft in 15 Minuten ab.",
		spamFolderNote:
			"💡 Bitte überprüfen Sie Ihren Spam-/Junk-Ordner, wenn Sie die E-Mail nicht sehen.",
		didntReceiveEmail: "Keine E-Mail erhalten?",
		tryAgain: "Erneut versuchen",
		resetEmailSent: "E-Mail zum Zurücksetzen des Passworts gesendet!",
		failedToSend: "E-Mail zum Zurücksetzen konnte nicht gesendet werden",
		errorOccurred: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
	},

	groupSelection: {
		title: "Einer Gruppe beitreten",
		subtitle:
			"Verbinden Sie sich mit anderen Teilnehmern für die Testläufe. Sie können Ihre eigene Gruppe erstellen, einer bestehenden beitreten oder alleine teilnehmen.",
		createGroup: "Gruppe erstellen",
		createGroupDescription:
			"Erstellen Sie eine neue Gruppe und laden Sie andere ein, sich Ihnen für den jeweiligen Probebetriebstag anzuschließen. Sie werden der Gruppenleiter sein.",
		joinGroup: "Gruppe beitreten",
		joinGroupDescription:
			"Geben Sie eine Gruppennummer ein, um einer bestehenden Gruppe beizutreten. Fragen Sie den Gruppenleiter nach seiner Gruppennummer.",
		aboutGroups: "Über Gruppen",
		aboutGroupsDescription:
			"Gruppen können bis zu 4 Mitglieder haben, die sich gegenseitig beim jeweiligen Probebetriebstag helfen und den besonderen Tag gemeinsam erleben.",
		loadingGroups: "Gruppeninformationen werden geladen...",
		errorLoadingGroups: "Fehler beim Laden der Gruppe",
	},

	groupManagement: {
		title: "Gruppenverwaltung",
		myGroups: "Meine Gruppen",
		createGroup: "Gruppe erstellen",
		joinGroup: "Gruppe beitreten",
		leaveGroup: "Gruppe verlassen",
		deleteGroup: "Gruppe löschen",
		groupDetails: "Gruppendetails",
		members: "Mitglieder",
		pending: "Ausstehend",
		settings: "Einstellungen",
		loading: "Gruppeninformationen werden geladen...",
		groupMembers: "Gruppenmitglieder",
		groupLeader: "Gruppenleiter",
		you: "Sie",
		member: "Mitglied",
		yearsOld: "Jahre",
		inviteMembers: "Mitglieder einladen",
		inviteDescription:
			"Teilen Sie diese Gruppennummer mit anderen, damit sie Ihrer Gruppe beitreten können:",
		copyNumber: "Nummer kopieren",
		copied: "Kopiert!",
		shareGroupNumber: "Gruppennummer teilen",
		inviteMoreMembers: "Weitere Mitglieder einladen",
		groupFull: "Gruppe ist voll",
		maxMembers: "Mitglieder",
		leaving: "Verlassen...",
		confirmLeaveTitle: "Gruppe verlassen bestätigen",
		confirmLeaveMessage: "Sind Sie sicher, dass Sie verlassen möchten",
		importantNotice: "Wichtiger Hinweis",
		leaveWarnings: {
			loseAccess: "Sie verlieren den Zugriff auf diese Gruppe",
			loseEventApplications: "Sie verlieren alle Ihre Terminanmeldungen",
			needNewCode:
				"Sie benötigen einen neuen Gruppencode, um wieder beizutreten",
			ownerWarning: "Als Gruppenbesitzer wird die Gruppe aufgelöst",
		},
		cancel: "Abbrechen",
		removeMember: "Mitglied entfernen",
		confirmRemoveMember:
			"Sind Sie sicher, dass Sie {name} aus der Gruppe entfernen möchten?",
		failedToRemove: "Mitglied konnte nicht entfernt werden",
		failedToCopy: "Gruppennummer konnte nicht kopiert werden",
		joinMyGroup: "Meiner Gruppe beitreten",
		joinMyGroupText:
			'Treten Sie meiner Gruppe "{name}" für den Probebetrieb im Terminal 3 bei! Gruppennummer: {number}',
		deleting: "Löschen...",
		confirmDeleteTitle: "Gruppe löschen",
		confirmDeleteMessage:
			"Sind Sie sicher, dass Sie diese Gruppe {{group_name}} löschen möchten?",
		warningTitle: "Diese Aktion kann nicht rückgängig gemacht werden",
		deleteWarnings: {
			permanent:
				"Diese Aktion ist dauerhaft und kann nicht rückgängig gemacht werden",
			membersRemoved: "Alle Mitglieder werden aus der Gruppe entfernt",
			cannotUndo: "Die Gruppe und alle ihre Daten werden dauerhaft gelöscht",
		},
		removeWarnings: {
			memberWillBeRemoved: "Dieses Mitglied wird aus der Gruppe entfernt",
			memberNeedsNewCode:
				"Es benötigt eine neue Gruppennummer zum erneuten Beitritt",
			cannotUndo: "Diese Aktion kann nicht rückgängig gemacht werden",
		},
		unnamedGroup: "Unbenannte Gruppe",
		groupCreator: "Gruppenersteller",
		defaultNationality: "Deutsch",
		confirmRemoveMemberTitle: "Gruppenmitglied entfernen",
		confirmRemoveMemberMessage: "Sind Sie sicher, dass Sie",
		removingMember: "Entfernen...",
		membersCount: "{{count}}/{{max}} Mitglieder",
		inviteMember: "Mitglied einladen",
		inviteModalDescription:
			"Geben Sie die E-Mail-Adresse der Person ein, die Sie in Ihre Gruppe einladen möchten. Bitte beachten Sie, dass es sich um die identische E-Mail-Adresse handeln muss, die von der Person zur Anmeldung zum Probebetrieb genutzt wurde.",
		emailAddress: "E-Mail-Adresse",
		emailPlaceholder: "beispiel@email.com",
		emailRequired: "E-Mail-Adresse ist erforderlich",
		invalidEmailFormat: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
		emailTooShort: "E-Mail-Adresse ist zu kurz",
		emailTooLong: "E-Mail-Adresse ist zu lang",
		invitationFailed:
			"Einladung konnte nicht gesendet werden. Bitte versuchen Sie es erneut.",
		invitationSentSuccess: "Einladung erfolgreich gesendet!",
		userAddedAndInvited:
			"Benutzer zur Gruppe hinzugefügt und Einladung erfolgreich gesendet!",
		userAddedToGroup: "Benutzer erfolgreich zur Gruppe hinzugefügt!",
		userAlreadyInGroup: "Dieser Benutzer ist bereits Mitglied der Gruppe",
		userNotFound: "Kein Benutzer mit dieser E-Mail-Adresse gefunden.",
		userNotVerified:
			"Dieser Benutzer muss zuerst seine E-Mail-Adresse verifizieren, bevor er zu einer Gruppe eingeladen werden kann.",
		sending: "Senden...",
		sendInvitation: "Einladung senden",
	},

	groupCreate: {
		title: "Neue Gruppe erstellen",
		subtitle:
			"Nachdem Sie die Gruppe eingerichtet haben, können Sie andere Teilnehmer zum Beitritt einladen.",
		groupName: "Gruppenname",
		groupNamePlaceholder: "Geben Sie einen Namen für Ihre Gruppe ein",
		groupNameHint: "Wählen Sie einen einprägsamen Namen für Ihre Gruppe",
		description: "Beschreibung",
		groupDescription: "Gruppenbeschreibung (Optional)",
		descriptionPlaceholder: "Kurze Beschreibung Ihrer Gruppe (optional)",
		groupDescriptionPlaceholder: "Worum geht es in Ihrer Gruppe?",
		maxMembers: "Maximale Mitglieder",
		privacy: "Privatsphäre",
		public: "Öffentlich",
		private: "Privat",
		create: "Gruppe erstellen",
		createGroup: "Gruppe erstellen",
		creating: "Wird erstellt...",
		success: "Gruppe erfolgreich erstellt!",
		createdSuccessfully: "Gruppe erfolgreich erstellt!",
		nameRequired: "Gruppenname ist erforderlich",
		failedToCreate: "Gruppe konnte nicht erstellt werden",
		groupInformationTitle: "Gruppeninformationen",
		maxMembersInfo: "Maximal 4 Mitglieder pro Gruppe",
		leaderPrivilegesInfo: "Sie sind der Gruppenleiter mit Verwaltungsrechten",
		shareGroupNumberInfo: "Teilen Sie die Gruppennummer, um andere einzuladen",
		errors: {
			nameRequired: "Gruppenname ist erforderlich",
			nameTooShort: "Gruppenname muss mindestens 3 Zeichen lang sein",
			nameTooLong: "Gruppenname darf maximal 30 Zeichen lang sein",
			descriptionTooLong: "Beschreibung darf maximal 100 Zeichen lang sein",
			failed:
				"Gruppe konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
		},
	},

	groupJoin: {
		title: "Einer Gruppe beitreten",
		subtitle:
			"Geben Sie die vom Gruppenleiter bereitgestellte Gruppennummer ein, um seinem Team beizutreten",
		groupNumber: "Gruppennummer",
		groupCode: "Gruppencode",
		groupNumberRequired: "*",
		placeholder: "12345678",
		helpText: "Fragen Sie den Gruppenleiter nach der 8-stelligen Gruppennummer",
		groupFound: "Gruppe gefunden!",
		previewTitle: "Gruppe gefunden",
		previewMessage:
			"Klicken Sie auf 'Gruppe beitreten', um Mitglied dieser Gruppe zu werden",
		memberCount: "Mitglieder",
		groupFull: "Gruppe voll",
		groupFullMessage:
			"Diese Gruppe ist voll und kann keine neuen Mitglieder aufnehmen",
		successTitle: "Erfolgreich der Gruppe beigetreten!",
		redirecting: "Weiterleitung zu Ihrer Gruppe...",
		members: "Mitglieder",
		member: "Mitglied",
		private: "privat",
		public: "öffentlich",
		cancel: "Abbrechen",
		joinGroup: "Gruppe beitreten",
		joining: "Beitreten...",
		infoTitle: "Einer Gruppe beitreten",
		infoPoints: {
			member: "Sie werden Mitglied der Gruppe",
			leader: "Der Gruppenleiter verwaltet die Gruppeneinstellungen",
			leave: "Sie können die Gruppe jederzeit verlassen",
		},
		errors: {
			groupNotFound:
				"Gruppe nicht gefunden. Bitte überprüfen Sie die Gruppennummer.",
			groupFull:
				"Diese Gruppe ist voll (4/4 Mitglieder). Versuchen Sie eine andere Gruppennummer.",
			validNumber: "Bitte geben Sie eine gültige 8-stellige Gruppennummer ein",
			loadFailed:
				"Gruppeninformationen konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
			notFoundTitle: "Gruppe nicht gefunden",
			notFoundMessage: "Wir konnten keine Gruppe mit der Nummer finden",
			notFoundHint:
				"Überprüfen Sie die Gruppennummer mit Ihrem Gruppenleiter oder versuchen Sie eine andere Nummer",
			fullTitle: "Gruppe ist voll",
			fullMessage:
				"Diese Gruppe hat ihre maximale Kapazität von 4 Mitgliedern erreicht.",
			fullHint:
				"Bitte versuchen Sie einer anderen Gruppe beizutreten oder erstellen Sie Ihre eigene.",
		},
	},

	// Bottom Sheet Component
	bottomSheet: {
		contractProcess: "Vertragsprozess",
		howToComplete: "So vervollständigen Sie Ihren Vertrag",
		step1: "Laden Sie Ihren Arbeitsvertrag herunter",
		step2: "Drucken und unterschreiben Sie den Vertrag",
		step3: "Senden Sie den unterschriebenen Vertrag an:",
		step4:
			"Wir bearbeiten Ihren Vertrag und senden Ihnen die UCM-unterschriebene Version zurück",
		ucmContractDepartment: "UCM Vertragsabteilung",
		orMailTo: "oder senden an:",
		ucmAgency: "UCM Agency",
		contractDepartment: "Vertragsabteilung",
		address1: "Musterstraße 123",
		address2: "60329 Frankfurt am Main",
		processingTime: "Bearbeitungszeit:",
		processingDays: "2-3 Werktage",
		downloadContract: "Vertrag herunterladen",
		doThisLater: "Das mache ich später",
	},

	// Contract Data Intro Overlay
	contractDataIntro: {
		title: "Vertragsdaten",
		subtitle:
			"Ihre Vertragsinformationen helfen uns bei der Vorbereitung der notwendigen Arbeitsunterlagen und stellen die Einhaltung der deutschen Arbeitsgesetze sicher.",
		usedFor: "Diese Informationen werden verwendet für:",
		legalEmployment: "Rechtliche Beschäftigung",
		legalEmploymentDesc:
			"Erstellung konformer Arbeitsverträge gemäß deutschen Vorschriften.",
		taxDocumentation: "Steuerliche Dokumentation",
		taxDocumentationDesc:
			"Ordnungsgemäße Steuerklassifizierung und Dokumentation für die Lohnabrechnung.",
		insuranceCoverage: "Versicherungsschutz",
		insuranceCoverageDesc:
			"Sicherstellung angemessenen Versicherungsschutzes während Ihrer Beschäftigung.",
		privacyNote:
			"Alle Vertragsdaten werden in strikter Einhaltung der deutschen Datenschutzgesetze (DSGVO/GDPR) und Arbeitsvorschriften behandelt.",
		consentNote:
			"Diese Informationen sind für die rechtmäßige Beschäftigung unerlässlich und können nicht ohne Ihre Zustimmung verarbeitet werden.",
		okayGotIt: "Okay, verstanden",
		why: "Warum wir diese Informationen benötigen",
		reason1: "Rechtliche Compliance",
		reason1Desc: "Sicherstellung der Einhaltung deutscher Arbeitsgesetze",
		reason2: "Gehaltsabrechnung",
		reason2Desc: "Korrekte Berechnung Ihrer Vergütung",
		reason3: "Versicherung",
		reason3Desc: "Bereitstellung angemessener Versicherungsdeckung",
		continue: "Weiter zu Vertragsdaten",
	},

	// Code of Conduct Intro
	codeOfConductIntro: {
		title: "Verhaltenskodex",
		whyImportant: "Warum diese Vereinbarung wichtig ist",
		safetyFirst: "Sicherheit geht vor",
		safetyFirstDesc:
			"Flughafenoperationen erfordern strenge Sicherheitsprotokolle zum Schutz aller Teilnehmer und Flughafenoperationen.",
		professionalStandards: "Professionelle Standards",
		professionalStandardsDesc:
			"Klare Richtlinien stellen sicher, dass alle Teilnehmer während der Probebetriebe professionelles Verhalten zeigen.",
		confidentiality: "Vertraulichkeit",
		confidentialityDesc:
			"Flughafen-Probedaten sind sensibel und erfordern Vertraulichkeitsvereinbarungen zum Schutz operativer Informationen.",
		clearExpectations: "Klare Erwartungen:",
		clearExpectationsDesc:
			"Der Verhaltenskodex schützt alle und sorgt für eine positive Erfahrung für alle Teilnehmer.",
		reviewCodeOfConduct: "Verhaltenskodex prüfen",
	},

	// Info & FAQ
	infoFAQ: {
		subtitle:
			"Erhalten Sie hilfreiche Informationen und Antworten auf häufige Fragen.",
		registrationTitle: "FAQ",
		registrationDescription:
			"Weitere Informationen zum Registrierungsprozess und den Anforderungen finden Sie auf unserer Homepage.",
		visitRegistrationPage: "Homepage Besuchen",
		contactTitle: "Brauchen Sie weitere Hilfe?",
		contactDescription:
			"Für Unterstützung oder bei weiteren Fragen können Sie uns eine E-Mail senden. Wir melden uns so schnell wie möglich bei Ihnen.",
		sendEmail: "E-Mail senden",
	},
};
